import styled from 'styled-components';
import { Typ20, Typ31 } from 'dc/Typ';
import Lab110 from 'dc/Lab110';

export const TextWrapper = styled.div`
  min-width: 124px;
  margin-right: 16px;
  background-color: transparent;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding-left: 16px;
`;

type TitleProps = {
  $inactive: boolean;
};

export const Title = styled(Typ31)<TitleProps>`
  line-height: 22px;

  &:first-letter {
    text-transform: capitalize;
  }

  color: ${props => (props.$inactive ? '#b0bec5' : 'inherit')};
`;

type DescriptionProps = {
  $inactive: boolean;
};

export const Description = styled(Typ20)<DescriptionProps>`
  color: ${props => (props.$inactive ? '#b0bec5' : 'inherit')};
`;

type SavingsProps = {
  $inactive: boolean;
  $color?: string;
};

export const Savings = styled(Lab110)<SavingsProps>`
  width: 48px;
  cursor: pointer;

  i {
    color: ${props => (props.$inactive ? '#b0bec5' : props.color || '#00ab97')};
  }

  span {
    color: ${props => (props.$inactive ? '#b0bec5' : 'inherit')};
  }
`;
